// ContactField.tsx
import { motion } from 'framer-motion';

interface ContactFieldProps {
  field: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  error?: string;
  type?: 'text' | 'email';
}

const ContactField: React.FC<ContactFieldProps> = ({ field, value, onChange, error, type = 'text' }) => {
  return (
    <motion.div variants={{ visible: { opacity: 1 } }} initial="hidden" animate="visible" className="space-y-4">
      <label htmlFor={field} className="block text-sm font-medium text-[#1e3a8a] mb-3">
        {field.charAt(0).toUpperCase() + field.slice(1)}
      </label>
      {type === 'text' ? (
        <input
          type="text"
          id={field}
          value={value}
          onChange={onChange}
          className={`w-full px-5 py-3.5 rounded-xl border ${
            error ? 'border-red-300' : 'border-[#1e3a8a]/20'
          } focus:ring-2 focus:ring-[#1e3a8a] focus:border-[#1e3a8a] text-[#1c3d6e]`}
          aria-invalid={!!error}
          aria-describedby={`${field}-error`}
        />
      ) : (
        <input
          type="email"
          id={field}
          value={value}
          onChange={onChange}
          className={`w-full px-5 py-3.5 rounded-xl border ${
            error ? 'border-red-300' : 'border-[#1e3a8a]/20'
          } focus:ring-2 focus:ring-[#1e3a8a] focus:border-[#1e3a8a] text-[#1c3d6e]`}
          aria-invalid={!!error}
          aria-describedby={`${field}-error`}
        />
      )}
      {error && (
        <motion.p
          id={`${field}-error`}
          className="mt-2 text-sm text-red-600"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
        >
          {error}
        </motion.p>
      )}
    </motion.div>
  );
};

export default ContactField;
